import React, { useCallback, useState } from 'react';
import { withStyles } from '@material-ui/core/styles';
import { AppBar, Box, Toolbar, IconButton, Drawer, Typography } from '@material-ui/core';
import MenuIcon from '@material-ui/icons/Menu';
import HelpIcon from '@material-ui/icons/Help';
import Navigation from './Navigation/Navigation';
import { useHistory } from 'react-router-dom';

const styles = {
    root: {
        flexGrow: 1
    }, 
    grow: {
        flexGrow: 1
    }, 
    menuButton: {
        marginLeft: -12, 
        marginRight: 20
    }
};

const Header = ({ isAuthenticated = false, classes }) => {
    const [drawerIsOpen, setDrawerIsOpen] = useState();
    const history = useHistory();

    const onCloseHandler = useCallback(() => {
        setDrawerIsOpen(false);
    }, [setDrawerIsOpen]);

    const onOpenHandler = useCallback(() => {
        setDrawerIsOpen(true);
    }, [setDrawerIsOpen]);

    const onHelpClickHandler = useCallback(() => {
        history.push('/faq');
    }, [history]);

    return (
        <div className={classes.root}>
            <AppBar>
                <Toolbar>
                    { isAuthenticated ? <IconButton 
                        className={classes.menuButton}
                        color="inherit" 
                        aria-label="Menu" 
                        onClick={onOpenHandler} 
                    >
                        <MenuIcon />
                    </IconButton> : null }
                    <Typography className={classes.grow} variant="h6" color="inherit">Leonard's Driver Portal</Typography>
                    { isAuthenticated && <IconButton 
                        color="inherit" 
                        aria-label="Menu" 
                        onClick={onHelpClickHandler} 
                    >
                        <HelpIcon />
                    </IconButton>}
                </Toolbar>
            </AppBar>
            { isAuthenticated ? <Drawer open={drawerIsOpen} onClose={onCloseHandler}>
                <Box style={{ display: 'flex',  alignItems: 'center', justifyContent: 'center'}} pt={1}>
                    <img src={process.env.PUBLIC_URL + '/images/logo-small.png'} alt='Logo' width="168" height="104" />
                </Box>
                <Navigation onCloseHandler={onCloseHandler} />
            </Drawer> : null }
        </div>
    );
}

export default withStyles(styles)(Header);